import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Spinner,
  Card,
  Alert,
  Tabs,
  Tab,
  Row,
  Col,
  Badge,
} from "react-bootstrap";

import api from "../components/Api";
import Pustakapi from "../components/Pustak";

export default function AddQuestion() {
  const [school, setSchool] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [quesbank, setQuesBank] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [autoCreatingBank, setAutoCreatingBank] = useState(false);

  // Strategy Setup States
  const [isDemo, setIsDemo] = useState(false);
  const [isManualMode, setIsManualMode] = useState(false);

  // Manual Question Composition State
  const [manualQuestion, setManualQuestion] = useState({
    question: "",
    options: ["", "", "", ""],
    correct_answer: "",
  });

  const [form, setForm] = useState({
    school_id: "",
    class_id: "",
    class_catid: "",
    subject_id: "",
    chapter_id: "",
    num_questions: 5,
    quest_typeId: "",
    quest_type: "",
    description: "",
    quest_bankId: "",
    auto_bank_name: "",
  });

  // ================= QUESTION TYPES =================
  useEffect(() => {
    api
      .get("/pustak-questionbank/getquestype")
      .then((res) => {
        if (res.data.status === "success") {
          setQuestionTypes(res.data.data || []);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // ================= SCHOOL =================
  useEffect(() => {
    Pustakapi
      .get("/webapi?method=getMasterCategoryDataMobile")
      .then((res) => {
        setSchool(res.data.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  // ================= LOAD BANKS =================
  const loadBanks = async () => {
    try {
      const res = await api.get("/questionbank/banks");
      if (res.data.status === "success") {
        setQuesBank(res.data.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadBanks();
  }, []);

  // ================= LOAD CLASSES =================
  useEffect(() => {
    if (form.school_id) {
      setClasses([]);
      setSubjects([]);
      setChapters([]);

      Pustakapi.get(
        `/webapi?method=getsubcatByCategory&data={"category_id":"${form.school_id}"}`
      )
        .then((res) => {
          setClasses(res.data.data || []);
        })
        .catch((err) => console.log(err));
    }
  }, [form.school_id]);

  // ================= LOAD SUBJECTS =================
  useEffect(() => {
    if (form.class_id && form.class_catid) {
      setSubjects([]);
      setChapters([]);

      Pustakapi.get("/webapi?", {
        params: {
          method: "getbookDataBySubCategory",
          data: JSON.stringify({
            category_id: form.class_catid,
            subcat_id: form.class_id,
          }),
        },
      })
        .then((res) => {
          setSubjects(res.data.data || []);
        })
        .catch((err) => console.log(err));
    }
  }, [form.class_id, form.class_catid]);

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    // CLASS
    if (name === "class_id") {
      const [id, catid] = value.split("|");
      setForm((prev) => ({
        ...prev,
        class_id: id,
        class_catid: catid,
        subject_id: "",
        chapter_id: "",
        auto_bank_name: "",
      }));
      return;
    }

    // QUESTION TYPE
    if (name === "quest_typeId") {
      const selected = questionTypes.find((q) => q.id == value);
      setForm((prev) => ({
        ...prev,
        quest_typeId: value,
        quest_type: selected?.quesType || "",
      }));

      // Flush local manual structures to synchronize cleanly on type change
      setManualQuestion({
        question: "",
        options: ["", "", "", ""],
        correct_answer: "",
      });
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ================= SERIES API =================
  const getSeriesData = (subject) => {
    Pustakapi.get(
      `/webapi?method=getbookBySeries&data={"series_id":"${subject.bookID}"}`
    )
      .then((res) => {
        setChapters(res.data.data || []);
      })
      .catch((err) => console.log(err));
  };

  // ================= CHAPTER API =================
  const getChapterData = (subject) => {
    Pustakapi.get(
      `/webapi?method=getChapterByBook&data={"book_id":"${subject.bookID}"}`
    )
      .then((res) => {
        setChapters(res.data.data || []);
      })
      .catch((err) => console.log(err));
  };

  // ================= SUBJECT CHANGE =================
  const handleSubjectChange = (e) => {
    const selectedId = e.target.value;
    setForm((prev) => ({
      ...prev,
      subject_id: selectedId,
      chapter_id: "",
      auto_bank_name: "",
    }));

    const selectedSubject = subjects.find((s) => s.bookID == selectedId);
    if (selectedSubject) {
      if (selectedSubject.is_series === "1" || selectedSubject.is_series === 1) {
        getSeriesData(selectedSubject);
      } else {
        getChapterData(selectedSubject);
      }
    }
  };

  // ================= AUTO CREATE QUESTION BANK =================
  const createAutoQuestionBank = async (
    schoolName,
    className,
    subjectName,
    chapterName
  ) => {
    try {
      setAutoCreatingBank(true);
      const autoTitle = `${schoolName} - ${className} - ${subjectName} - ${chapterName}`;

      const existing = quesbank.find(
        (q) => q.bank_name.trim().toLowerCase() === autoTitle.trim().toLowerCase()
      );

      if (existing) {
        setForm((prev) => ({
          ...prev,
          quest_bankId: existing.bank_id,
          auto_bank_name: autoTitle,
        }));
        setMessage(`ℹ️ Question bank already exists: ${autoTitle}`);
        return;
      }

      const payload = {
        bank_name: autoTitle,
        description: `Auto generated question bank for ${chapterName}`,
      };

      const res = await api.post("/questionbank/bank", payload);
      if (res.data.status === "success") {
        setMessage("✅ Auto Question Bank Created Successfully");
        const bankRes = await api.get("/questionbank/banks");
        const updatedBanks = bankRes.data.data || [];
        setQuesBank(updatedBanks);

        const latestBank = updatedBanks.find(
          (b) => b.bank_name.trim().toLowerCase() === autoTitle.trim().toLowerCase()
        );

        if (latestBank) {
          setForm((prev) => ({
            ...prev,
            quest_bankId: latestBank.bank_id,
            auto_bank_name: autoTitle,
          }));
        }
      }
    } catch (err) {
      console.log(err);
      setMessage("❌ Failed to create auto bank");
    } finally {
      setAutoCreatingBank(false);
    }
  };

  // ================= CHAPTER CHANGE =================
  const handleChapterChange = async (e) => {
    const chapterId = e.target.value;
    const selectedSchool = school.find((s) => s.id == form.school_id);
    const selectedClass = classes.find((c) => c.id == form.class_id);
    const selectedSubject = subjects.find((s) => s.bookID == form.subject_id);
    const selectedChapter = chapters.find((c) => c.BookID == chapterId);

    const autoName = `${selectedSchool?.category_name || ""} - ${selectedClass?.name || ""} - ${selectedSubject?.book_english_name || ""} - ${selectedChapter?.book_english_name || ""}`;

    setForm((prev) => ({
      ...prev,
      chapter_id: chapterId,
      auto_bank_name: autoName,
    }));

    await createAutoQuestionBank(
      selectedSchool?.category_name || "",
      selectedClass?.name || "",
      selectedSubject?.book_english_name || "",
      selectedChapter?.book_english_name || ""
    );
  };

  // ================= AI GENERATE =================
  const handleGenerate = async (isDemoValue = false) => {
    setLoading(true);
    setQuestions([]);
    setMessage("");

    try {
      const selectedSchool = school.find((s) => s.id == form.school_id);
      const selectedClass = classes.find((c) => c.id == form.class_id);
      const selectedSubject = subjects.find((s) => s.bookID == form.subject_id);
      const selectedChapter = chapters.find((c) => c.BookID == form.chapter_id);

      // Determine series flag for persistence schema mapping
      const isSeriesVal = selectedSubject 
        ? (selectedSubject.is_series == 1 || selectedSubject.is_series === "1" ? 1 : 0) 
        : 0;

      const payload = {
        category_id: form.school_id,
        subcategory_id: form.class_id,
        series_id: form.subject_id,
        book_id: form.chapter_id,
        isSeries: isSeriesVal,
        cat_name: selectedSchool?.category_name || "",
        subcat_name: selectedClass?.name || "",
        series_name: selectedSubject?.book_english_name || "",
        book_name: selectedChapter?.book_english_name || "",
        num_questions: form.num_questions,
        quest_typeId: form.quest_typeId,
        questtype: form.quest_type,
        description: form.description,
        quesbankid: form.quest_bankId,
        is_demo: isDemoValue ? 1 : 0,
        is_manual: false // Signals the backend to use the AI prompt pipeline
      };

      console.log("AI Generation Payload:", payload);
      const res = await api.post("/pustak-questionbank/generateques", payload);

      if (res.data.status === "success") {
        setQuestions(res.data.questions || []);
        setMessage("✅ Questions generated successfully");
      } else {
        setMessage(`❌ Failed: ${res.data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.log(err);
      setMessage("❌ API Error");
    } finally {
      setLoading(false);
    }
  };

  // ================= MANUAL SUBMIT (ROUTED TO UNIFIED ENDPOINT) =================
  const handleManualSubmit = async () => {
    if (questions.length === 0) {
      setMessage("❌ Add at least one question to the staging pool before submitting.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const selectedSchool = school.find((s) => s.id == form.school_id);
      const selectedClass = classes.find((c) => c.id == form.class_id);
      const selectedSubject = subjects.find((s) => s.bookID == form.subject_id);
      const selectedChapter = chapters.find((c) => c.BookID == form.chapter_id);

      const isSeriesVal = selectedSubject 
        ? (selectedSubject.is_series == 1 || selectedSubject.is_series === "1" ? 1 : 0) 
        : 0;

      const payload = {
        category_id: form.school_id,
        subcategory_id: form.class_id,
        series_id: form.subject_id,
        book_id: form.chapter_id,
        isSeries: isSeriesVal,
        cat_name: selectedSchool?.category_name || "",
        subcat_name: selectedClass?.name || "",
        series_name: selectedSubject?.book_english_name || "",
        book_name: selectedChapter?.book_english_name || "",
        quest_typeId: form.quest_typeId,
        questtype: form.quest_type,
        quesbankid: form.quest_bankId,
        is_demo: isDemo ? 1 : 0,
        is_manual: true, // Signals the backend to bypass AI and loop through custom inputs
        questions: questions
      };

      console.log("Manual Submission Payload:", payload);
      // Both features point safely to your unified method handler
      const res = await api.post("/pustak-questionbank/generateques", payload);

      if (res.data.status === "success") {
        setMessage("✅ Manual questions submitted and saved successfully!");
        setQuestions([]); 
      } else {
        setMessage(`❌ Failed to save manual questions: ${res.data.message || ''}`);
      }
    } catch (err) {
      console.log(err);
      setMessage("❌ API Submission Error");
    } finally {
      setLoading(false);
    }
  };

  // ================= MANUAL SETUP LOCAL HANDLERS =================
  const handleManualInputChange = (e) => {
    const { name, value } = e.target;
    setManualQuestion((prev) => ({ ...prev, [name]: value }));
  };

  const handleManualOptionChange = (index, value) => {
    setManualQuestion((prev) => {
      const updatedOptions = [...prev.options];
      updatedOptions[index] = value;
      return { ...prev, options: updatedOptions };
    });
  };

  const addManualQuestionToList = () => {
    if (!manualQuestion.question.trim()) {
      setMessage("❌ Question text is missing!");
      return;
    }

    const typeNormalized = form.quest_type.toUpperCase();
    const isTrueFalse = typeNormalized.includes("TRUE") || typeNormalized.includes("FALSE") || typeNormalized.includes("TF");

    let formattedNode = {};

    if (isTrueFalse) {
      if (!manualQuestion.correct_answer) {
        setMessage("❌ Select True or False to confirm the correct answer.");
        return;
      }
      formattedNode = {
        question: manualQuestion.question.trim(),
        correct_answer: manualQuestion.correct_answer,
      };
    } else {
      if (manualQuestion.options.some((opt) => !opt.trim())) {
        setMessage("❌ Please complete all 4 option text blocks.");
        return;
      }
      if (!manualQuestion.correct_answer) {
        setMessage("❌ Select a correct option text block via the radio checker.");
        return;
      }
      formattedNode = {
        question: manualQuestion.question.trim(),
        options: manualQuestion.options.map((o) => o.trim()),
        correct_answer: manualQuestion.correct_answer,
      };
    }

    setQuestions((prev) => [...prev, formattedNode]);
    setMessage("✅ Created question saved into the pool collection successfully.");

    setManualQuestion({
      question: "",
      options: ["", "", "", ""],
      correct_answer: "",
    });
  };

  const isTypeTrueFalse =
    form.quest_type.toUpperCase().includes("TRUE") ||
    form.quest_type.toUpperCase().includes("FALSE") ||
    form.quest_type.toUpperCase().includes("TF");

  return (
    <Container fluid className="py-4">
      {/* HEADER CARD */}
      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body>
          <h3 className="mb-3">🧠 AI Question Generator</h3>

          {message && (
            <Alert variant={message.includes("❌") ? "danger" : message.includes("ℹ️") ? "warning" : "success"}>
              {message}
            </Alert>
          )}

          <Form onSubmit={(e) => e.preventDefault()}>
            {/* ROW 1: CONTROLS */}
            <Row className="g-3 align-items-end">
              {/* QUESTION TYPE */}
              <Col md={4}>
                <Form.Label>Question Type</Form.Label>
                <Form.Select
                  name="quest_typeId"
                  value={form.quest_typeId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Type</option>
                  {questionTypes
                    .filter((q) => q.id !== "3" && q.id !== "4" && q.id !== "5")
                    .map((q) => (
                      <option key={q.id} value={q.id}>
                        {q.quesType}
                      </option>
                    ))}
                </Form.Select>
              </Col>

              {/* MANUAL vs AI STRATEGY TOGGLE */}
              <Col md={4} className="pb-1">
                <Form.Label className="d-block text-muted small fw-semibold">Creation Strategy</Form.Label>
                <Form.Check
                  type="switch"
                  id="strategy-switch"
                  label={isManualMode ? "Manual Setup Mode" : "AI Generation Mode"}
                  checked={isManualMode}
                  onChange={(e) => {
                    setIsManualMode(e.target.checked);
                    setQuestions([]);
                    setMessage("");
                  }}
                />
              </Col>

              {/* DEMO MODE TOGGLE */}
              <Col md={4} className="pb-1">
                <Form.Label>Demo Mode</Form.Label>
                <Form.Check
                  type="switch"
                  id="demo-switch"
                  label={isDemo ? "Demo Questions " : "Real Questions "}
                  checked={isDemo}
                  onChange={(e) => setIsDemo(e.target.checked)}
                />
              </Col>
            </Row>

            {/* ROW 2: FILTERS & FORMS */}
            <Row className="g-3 mt-2">
              {/* SCHOOL */}
              <Col md={3}>
                <Form.Label>School</Form.Label>
                <Form.Select name="school_id" value={form.school_id} onChange={handleChange} required>
                  <option value="">Select School</option>
                  {school.filter((s) => Number(s.id) !== 8).map((s) => (
                    <option key={s.id} value={s.id}>{s.category_name}</option>
                  ))}
                </Form.Select>
              </Col>

              {/* CLASS */}
              <Col md={3}>
                <Form.Label>Class</Form.Label>
                <Form.Select
                  name="class_id"
                  value={form.class_id && form.class_catid ? `${form.class_id}|${form.class_catid}` : ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Class</option>
                  {classes.map((c) => (
                    <option key={c.id} value={`${c.id}|${c.catid}`}>{c.name}</option>
                  ))}
                </Form.Select>
              </Col>

              {/* SUBJECT */}
              <Col md={3}>
                <Form.Label>Subject</Form.Label>
                <Form.Select value={form.subject_id} onChange={handleSubjectChange} required>
                  <option value="">Select Subject</option>
                  {subjects.map((s) => (
                    <option key={s.bookID} value={s.bookID}>{s.book_english_name}</option>
                  ))}
                </Form.Select>
              </Col>

              {/* CHAPTER */}
              <Col md={3}>
                <Form.Label>Chapter</Form.Label>
                <Form.Select value={form.chapter_id} onChange={handleChapterChange} required>
                  <option value="">Select Chapter</option>
                  {chapters.map((c) => (
                    <option key={c.BookID} value={c.BookID}>{c.book_english_name}</option>
                  ))}
                </Form.Select>
              </Col>

              {/* AUTO TITLE */}
              <Col md={12}>
                <Form.Label>Auto Generated Question Bank</Form.Label>
                <Form.Control value={form.auto_bank_name} readOnly />
              </Col>

              {/* STRATEGY BLOCK VIEW SWITCH */}
              {!isManualMode ? (
                <>
                  {/* AI PROMPT DESCRIPTION */}
                  <Col md={12}>
                    <Form.Label>AI Prompt</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      value={form.description}
                      onChange={handleChange}
                      placeholder="Enter AI prompt..."
                    />
                  </Col>

                  {/* NUMBER OF QUESTIONS */}
                  <Col md={3}>
                    <Form.Label>Number of Questions</Form.Label>
                    <Form.Control
                      type="number"
                      name="num_questions"
                      value={form.num_questions}
                      onChange={handleChange}
                      min={1}
                      max={100}
                    />
                  </Col>

                  {/* GENERATE ACTION BUTTON */}
                  <Col md={3} className="d-flex align-items-end">
                    <Button
                      type="button"
                      disabled={loading || autoCreatingBank}
                      onClick={() => handleGenerate(isDemo)}
                    >
                      {loading || autoCreatingBank ? <Spinner size="sm" /> : "Generate Questions"}
                    </Button>
                  </Col>
                </>
              ) : (
                <Col md={12}>
                  {!form.quest_typeId ? (
                    <Alert variant="warning" className="text-center py-3">
                      ⚠️ Please choose a specific <strong>Question Type</strong> from the dropdown choices above to initialize your manual layout inputs.
                    </Alert>
                  ) : (
                    <Row className="g-3">
                      {/* INPUT FIELDS AREA */}
                      <Col lg={7}>
                        <Card className="bg-light p-3 rounded-3 border-1 shadow-sm">
                          <h5 className="mb-3 text-secondary">⚙️ Question Input Editor ({form.quest_type})</h5>
                          
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Question Formulation</Form.Label>
                            <Form.Control
                              type="text"
                              name="question"
                              value={manualQuestion.question}
                              onChange={handleManualInputChange}
                              placeholder="Type your question here..."
                            />
                          </Form.Group>

                          {isTypeTrueFalse ? (
                            <Form.Group className="mb-3">
                              <Form.Label className="fw-semibold d-block">Designate Answer Key</Form.Label>
                              <Form.Check
                                inline
                                type="radio"
                                label="True"
                                name="correct_answer"
                                value="True"
                                checked={manualQuestion.correct_answer === "True"}
                                onChange={handleManualInputChange}
                                id="m-tf-true"
                              />
                              <Form.Check
                                inline
                                type="radio"
                                label="False"
                                name="correct_answer"
                                value="False"
                                checked={manualQuestion.correct_answer === "False"}
                                onChange={handleManualInputChange}
                                id="m-tf-false"
                              />
                            </Form.Group>
                          ) : (
                            <Row className="g-2 mb-3">
                              <Form.Label className="fw-semibold">Option Value Input Blocks</Form.Label>
                              {manualQuestion.options.map((option, index) => (
                                <Col md={12} key={index}>
                                  <div className="input-group">
                                    <span className="input-group-text bg-white">
                                      <Form.Check
                                        type="radio"
                                        name="correct_answer"
                                        value={option}
                                        checked={manualQuestion.correct_answer === option && option !== ""}
                                        disabled={!option.trim()}
                                        onChange={handleManualInputChange}
                                      />
                                    </span>
                                    <Form.Control
                                      type="text"
                                      placeholder={`Option String Row #${index + 1}`}
                                      value={option}
                                      onChange={(e) => handleManualOptionChange(index, e.target.value)}
                                    />
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          )}

                          <Button variant="success" className="w-100 py-2 mt-2" type="button" onClick={addManualQuestionToList}>
                            ➕ Commit & Add Question Into Pool
                          </Button>
                        </Card>
                      </Col>

                      {/* RENDERING PREVIEW AREA */}
                      <Col lg={5}>
                        <Card className="p-3 h-100 rounded-3 border-1 shadow-sm bg-white border-start border-4 border-info">
                          <h5 className="text-info mb-3">👁️ Live Component Creation Preview</h5>
                          {!manualQuestion.question.trim() && !manualQuestion.correct_answer ? (
                            <div className="d-flex align-items-center justify-content-center h-75 text-muted small text-center">
                              Draft details will render visually here as you compose input contents.
                            </div>
                          ) : (
                            <div>
                              <div className="mb-3">
                                <Badge bg="secondary" className="mb-2">{form.quest_type}</Badge>
                                <h6 className="fw-bold text-dark fs-5">
                                  {manualQuestion.question.trim() || "Untitled Question Frame..."}
                                </h6>
                              </div>

                              {!isTypeTrueFalse ? (
                                <ul className="list-group mb-3">
                                  {manualQuestion.options.map((opt, i) => (
                                    <li 
                                      key={i} 
                                      className={`list-group-item d-flex justify-content-between align-items-center ${
                                        manualQuestion.correct_answer === opt && opt !== "" ? "list-group-item-success" : ""
                                      }`}
                                    >
                                      <span>{opt.trim() || <span className="text-muted italic small">Empty choice Option {i+1}</span>}</span>
                                      {manualQuestion.correct_answer === opt && opt !== "" && <Badge bg="success">Correct Match</Badge>}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div className="d-flex gap-2 mb-3">
                                  <Button variant={manualQuestion.correct_answer === "True" ? "success" : "outline-secondary"} size="sm" disabled>True</Button>
                                  <Button variant={manualQuestion.correct_answer === "False" ? "danger" : "outline-secondary"} size="sm" disabled>False</Button>
                                </div>
                              )}

                              {manualQuestion.correct_answer && (
                                <div className="mt-2 p-2 rounded bg-light border text-success fw-bold small">
                                  🎯 Designated Answer Key: "{manualQuestion.correct_answer}"
                                </div>
                              )}
                            </div>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  )}
                </Col>
              )}
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {/* ACTIVE POOL DATA OUTPUT */}
      <Tabs defaultActiveKey="generated">
        <Tab eventKey="generated" title={`Generated Questions (${questions.length})`}>
          {questions.length === 0 ? (
            <p className="mt-4 text-muted">No questions generated yet</p>
          ) : (
            <div className="mt-4">
              {questions.map((q, i) => (
                <Card key={i} className="mb-3 shadow-sm border-start border-primary border-3">
                  <Card.Body>
                    <h6>Q{i + 1}: {q.question}</h6>
                    {Array.isArray(q.options) && (
                      <ul className="my-2">
                        {q.options.map((o, j) => (
                          <li key={j} className={q.correct_answer === o ? "text-success fw-bold" : ""}>
                            {o} {q.correct_answer === o && "✔️"}
                          </li>
                        ))}
                      </ul>
                    )}
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      {q.correct_answer && <Badge bg="success">Correct Key: {q.correct_answer}</Badge>}
                      <Badge bg={isDemo ? "secondary" : "dark"}>{isDemo ? "Demo Item" : "Live Item"}</Badge>
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {isManualMode && (
                <Button variant="primary" className="mt-2" disabled={loading} onClick={handleManualSubmit}>
                  {loading ? <Spinner size="sm" className="me-2" /> : "💾 "} Sync & Save All Manual Questions ({questions.length})
                </Button>
              )}
            </div>
          )}
        </Tab>
      </Tabs>
    </Container>
  );
}